const state = {
    showInfoPopup: false,
  };
  
  const mutations = {
    SET_INFO_POPUP(state, value) {
      state.showInfoPopup = value;
    },
  };
  
  const actions = {
    showPopupIfNeeded({ commit }) {
      const skipPopup = localStorage.getItem('skip_info_popup');
      const today = new Date();
      const thresholdDate = new Date('2025-07-01'); // дата после которой попап показывается
  
      if (!skipPopup && today > thresholdDate) {
        commit('SET_INFO_POPUP', true);
      }
    },
  
    closePopup({ commit }) {
      commit('SET_INFO_POPUP', false);
    },
  
    skipPopupPermanently({ commit }) {
      localStorage.setItem('skip_info_popup', '1');
      commit('SET_INFO_POPUP', false);
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
  };
  